import React from 'react';
import FunctionsList from '../Inputs/FunctionsList'
import { useSelector } from 'react-redux';
import UnderKonto from '../Inputs/UnderKonto'
import {Grid} from '@material-ui/core'
function RapportFunctions(props) {
    const isIamChild = useSelector(state=>state.accountsData.isIamChild)
    return (
        <div>
            <Grid container style={{ height: 'auto', padding: '10px' }}>
            <Grid item >
                <FunctionsList
                    handleChange={props.onChangeHandle}
                    Flags={props.Flags}
                    userRole={props.authUser.user_role}
                    userLicans={props.authUser.user_Licans}
                    />
                    </Grid>
                <Grid>
                {
                    parseInt(isIamChild) === 1?
                    <UnderKonto 
                    handleKontoChange={props.handleKontoChange}
                    Chips={props.Chips}
                    />
                    :""
                }
                </Grid>
            </Grid>
        </div>
    );
}

export default RapportFunctions;